export const getYouTubeIdFromURL = (url: string): string => {
  const youtubeRegexp =
    /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/gi

  let id = url.replace(youtubeRegexp, '$1')

  if (id.includes(';')) {
    const pieces = id.split(';')

    if (pieces[1].includes('%')) {
      const uriComponent = decodeURIComponent(pieces[1])
      id = ('http://youtube.com' + uriComponent).replace(youtubeRegexp, '$1')
    } else {
      id = pieces[0]
    }
  } else if (id.includes('#')) {
    id = id.split('#')[0]
  }

  return id
}

// https://developers.google.com/youtube/iframe_api_reference#Playback_status
export const YouTubePlayerState: {
  UNSTARTED: number
  ENDED: number
  PLAYING: number
  PAUSED: number
  BUFFERING: number
  CUED: number
} = {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5,
}

export interface YouTubePlayerEvent {
  data: (typeof YouTubePlayerState)[keyof typeof YouTubePlayerState]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  target: any
}

export interface YouTubePlayer {
  playVideo: () => void
  pauseVideo: () => void
  stopVideo: () => void
  // Add other methods as needed
}
